import * as React  from 'react'
import { connect } from 'react-redux'

import { queueToast }                    from '../../redux/index'
import { ReactComponent, UIState }       from '../../types'
import { Centered, InlineError, Loader } from '../atoms/index'

const actions = {
  queueToast,
}

interface LoadableProps {
  ui: UIState
  error?: any
  isCached?: boolean
}

type Props =
  LoadableProps
  & typeof actions

export default function loadable<P extends object> (Component: ReactComponent<P>) {
  class Loadable extends React.Component<Props & Partial<P>> {
    public componentDidUpdate (lastProps: Props) {
      const { ui, isCached } = this.props

      if (
        lastProps.ui === UIState.loading
        && ui !== UIState.loading
        && isCached
        && ui === UIState.failed
      ) {
        this.props.queueToast({ message: 'failedToUpdateContent' })
      }
    }

    public render () {
      /* the legendary typescript issue https://github.com/Microsoft/TypeScript/pull/13288 */
      const { error, ui, isCached, ...rest } = this.props as LoadableProps

      if (isCached) {
        return <Component {...rest} />
      }

      if (!isCached && ui === UIState.loaded) {
        return (
          <InlineError i18nErrorId={String(error || 'error.noDataAvailable')} />
        )
      }

      if (ui === UIState.loaded) {
        return (
          <Component {...rest} />
        )
      }

      if (ui === UIState.failed) {
        return (
          <InlineError i18nErrorId={String(error || 'error.failedToLoadResource')} />
        )
      }

      return (
        <Centered horizontally fullWidth>
          <Loader />
        </Centered>
      )
    }
  }

  return connect(null, actions)(Loadable) as any
}



// WEBPACK FOOTER //
// ./src/components/hocs/loadable.tsx